import React, { type FC } from "react";
import { BoType } from "@src/api/bo";
import { DivisionType } from "@src/api/dictionaries/divisions";
import { BoStateSelect, DivisionSearchSelect, EnterpriseSearchSelect } from "@src/components/business-data-entry";
import { BusinessForm } from "@src/components/business-form";
import { Input } from "@shared/ui/input";
import { FilterFormPanel } from "@shared/ui/form-panel";
import type { OnsideInvoiceFilter } from "../../../../../../api/onsideInvoices";
import type { ListFilterPanelProps } from "../../../../../../shared/listFilterPanel";
import {
    stockFinishedGoodsShipmentFilterFormConfig,
    StockFinishedGoodsShipmentFilterFormValues,
} from "./stockFinishedGoodsShipmentFilter.form-config";
import { useDivisionFilterSeed } from "@app/session-defaults/useDivisionFilterSeed";

/** Пропсы компонента {@link StockFinishedGoodsShipmentFilterForm}. */
export type StockFinishedGoodsShipmentFilterFormProps = ListFilterPanelProps<OnsideInvoiceFilter>;

/** Форма фильтра списка НС для отгрузки СГП. */
export const StockFinishedGoodsShipmentFilterForm: FC<StockFinishedGoodsShipmentFilterFormProps> = ({
    initialFilter,
    onApply,
}) => {
    const seed = useDivisionFilterSeed<StockFinishedGoodsShipmentFilterFormValues>("senderCode", {
        filter: { Types: [DivisionType.Склад] },
    });

    return (
        <FilterFormPanel
            initialFilter={initialFilter}
            seed={seed}
            submissionMemory={{
                key: "stock.finishedGoodsShipment.filter",
                schemaVersion: 1,
                fields: ["senderCode", "enterpriseCode", "stateCodes"],
            }}
            formProps={{ formConfig: stockFinishedGoodsShipmentFilterFormConfig }}
            toForm={(filter) => stockFinishedGoodsShipmentFilterFormConfig.toForm(filter)}
            toDomain={(values) => stockFinishedGoodsShipmentFilterFormConfig.toDomain(values)}
            onApply={onApply}
        >
            {(form) => (
                <>
                    <BusinessForm.Field name="senderCode">
                        <DivisionSearchSelect
                            {...form.field("senderCode").getSearchSelectProps((division) => division?.Code ?? null)}
                            flt={{ Types: [DivisionType.Склад] }}
                            fullscreenTitle="Выберите Склад СГП"
                        />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="enterpriseCode">
                        <EnterpriseSearchSelect
                            {...form.field("enterpriseCode").getSearchSelectProps((enterprise) => enterprise?.Code ?? null)}
                            fullscreenTitle="Выберите Контрагент-получатель"
                        />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="num">
                        <Input {...form.field("num").getPropsWithLabel()} />
                    </BusinessForm.Field>
                    <BusinessForm.Field name="stateCodes">
                        <BoStateSelect
                            {...form.field("stateCodes").getControlledPropsWithLabel()}
                            boType={BoType["Накладная на сторону"]}
                            multiple
                            clearable
                            fullscreenTitle="Выберите статус(ы) НС"
                        />
                    </BusinessForm.Field>
                </>
            )}
        </FilterFormPanel>
    );
};
